var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOtf = function SvgOtf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#otf_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M27 39c3.728 0 6.75-3.358 6.75-7.5S30.728 24 27 24s-6.75 3.358-6.75 7.5S23.272 39 27 39m0-1.5c1.243 0 2.25-2.686 2.25-6s-1.007-6-2.25-6-2.25 2.686-2.25 6 1.007 6 2.25 6",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#18B5C7",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.566 15q0 1.002-.39 1.69-.39.686-1.051 1.04a3.1 3.1 0 0 1-1.477.352 3.1 3.1 0 0 1-1.482-.355 2.64 2.64 0 0 1-1.049-1.042Q7.73 15.996 7.73 15q0-1.002.387-1.687.39-.69 1.049-1.04a3.1 3.1 0 0 1 1.482-.355q.815 0 1.477.355a2.6 2.6 0 0 1 1.052 1.04q.39.685.39 1.687m-1.676 0q0-.54-.143-.908a1.15 1.15 0 0 0-.419-.563 1.15 1.15 0 0 0-.68-.193q-.405 0-.682.193a1.17 1.17 0 0 0-.42.563q-.14.37-.14.908 0 .54.14.911.144.37.42.563.278.19.682.19.405 0 .68-.19.279-.194.419-.563.144-.372.143-.911m1.984-1.687V12h5.215v1.313h-1.805V18H15.68v-4.687zM19.702 18v-6h4.218v1.313h-2.59v1.03h2.333v1.313H21.33V18z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "otf_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgOtf;